import { Help } from 'e4shared';
import React from 'react';

export const TableListHover = ({ icon, data, uniqueKey }) => {
    const [ordered, setOrdered] = React.useState([]);

    React.useEffect(() => {
        setOrdered(data?.filter(d => d).sort((a, b) => (a > b ? 1 : -1)) || []);
    }, [data]);

    const preIcon = icon ? <i className={`fa ${icon} mr10`} /> : null;

    if (!ordered?.length) return <span>-</span>;

    if (ordered.length === 1)
        return (
            <span className="flex flex-center no-wrap">
                {preIcon}
                {ordered[0]}
            </span>
        );

    return (
        <span className="flex flex-center no-wrap">
            {preIcon}
            {ordered[0]}
            <Help id={`help-${uniqueKey}`} target={<span className="ml10 label label-grey">+{ordered.length - 1}</span>}>
                {ordered.map((d, i) => (
                    <div key={`help-item-${uniqueKey}-${i}`}>{d}</div>
                ))}
            </Help>
        </span>
    );
};

export default TableListHover;
